export const medicineTrackingTranslations = {
  ar: {
    title: 'تتبع الأدوية',
    addNew: 'إضافة دواء جديد',
    item: 'الصنف',
    store: 'المخزن',
    branch: 'الفرع',
    qrCode: 'رمز QR',
    serialNumber: 'الرقم التسلسلي',
    batchNumber: 'رقم الدفعة',
    gtin: 'GTIN',
    productionDate: 'تاريخ الإنتاج',
    expiryDate: 'تاريخ الانتهاء',
    manufacturingDate: 'تاريخ التصنيع',
    receivedDate: 'تاريخ الاستلام',
    initialQuantity: 'الكمية الأولية',
    currentQuantity: 'الكمية الحالية',
    unitCost: 'تكلفة الوحدة',
    supplier: 'المورد',
    notes: 'ملاحظات',
    isActive: 'نشط',
    isExpired: 'منتهي الصلاحية',
    sfdaProductCode: 'رمز المنتج في هيئة الدواء والغذاء',
    sfdaManufacturerCode: 'رمز الشركة المصنعة في هيئة الدواء والغذاء',
    sfdaAuthorizationNumber: 'رقم ترخيص هيئة الدواء والغذاء',
    scanQR: 'مسح رمز QR',
    parseQR: 'تحليل رمز QR',
    qrCodeData: 'بيانات رمز QR',
    invalidQRCode: 'رمز QR غير صالح',
    qrCodeNotFound: 'لم يتم العثور على هذا الرمز',
    batchNumberExists: 'رقم الدفعة مستخدم مسبقاً',
    serialNumberExists: 'الرقم التسلسلي مستخدم مسبقاً',
    expiringMedicines: 'أدوية قاربت على الانتهاء',
    expiredMedicines: 'أدوية منتهية الصلاحية',
    daysUntilExpiry: 'أيام متبقية حتى الانتهاء',
    daysExpired: 'أيام منذ الانتهاء',
    availableMedicines: 'الأدوية المتاحة',
    medicineDetails: 'تفاصيل الدواء',
    saveSuccess: 'تم حفظ بيانات الدواء بنجاح',
    saveError: 'تعذّر حفظ بيانات الدواء',
    deleteSuccess: 'تم حذف الدواء بنجاح',
    deleteError: 'تعذّر حذف الدواء',
    noMedicines: 'لا توجد أدوية مسجّلة',
    loading: 'جاري تحميل بيانات الأدوية...',
    error: 'تعذّر تحميل بيانات الأدوية',
    selectItem: 'اختر الصنف',
    selectStore: 'اختر المخزن',
    enableMedicineTracking: 'تفعيل نظام تتبع الأدوية',
    enableSFDATracking: 'تفعيل تتبع هيئة الدواء والغذاء (SFDA)',
    medicineTrackingEnabled: 'تم تفعيل نظام تتبع الأدوية',
    sfdTrackingEnabled: 'تم تفعيل تتبع هيئة الدواء والغذاء',
    selectAvailable: 'اختر من الأدوية المتاحة',
    scanOrPasteQR: 'امسح أو الصق رمز QR هنا',
    qrScannerTip: '💡 ملاحظة: يمكنك استخدام ماسح QR خارجي أو لصق الرمز مباشرة في الحقل',
    expired: 'منتهي الصلاحية',
    expiringSoon: 'سينتهي قريباً',
    medicineFound: 'تم العثور على الدواء من خلال رمز QR',
    medicineRecordCreated: 'تم إنشاء سجل التتبع للدواء بنجاح',
    confirmDelete: 'هل أنت متأكد من حذف هذا الدواء من نظام التتبع؟',
  },
  en: {
    title: 'Medicine Tracking',
    addNew: 'Add New Medicine',
    item: 'Item',
    store: 'Store',
    branch: 'Branch',
    qrCode: 'QR Code',
    serialNumber: 'Serial Number',
    batchNumber: 'Batch Number',
    gtin: 'GTIN',
    productionDate: 'Production Date',
    expiryDate: 'Expiry Date',
    manufacturingDate: 'Manufacturing Date',
    receivedDate: 'Received Date',
    initialQuantity: 'Initial Quantity',
    currentQuantity: 'Current Quantity',
    unitCost: 'Unit Cost',
    supplier: 'Supplier',
    notes: 'Notes',
    isActive: 'Active',
    isExpired: 'Expired',
    sfdaProductCode: 'SFDA Product Code',
    sfdaManufacturerCode: 'SFDA Manufacturer Code',
    sfdaAuthorizationNumber: 'SFDA Authorization Number',
    scanQR: 'Scan QR',
    parseQR: 'Parse QR',
    qrCodeData: 'QR Code Data',
    invalidQRCode: 'Invalid QR Code',
    qrCodeNotFound: 'QR Code not found',
    batchNumberExists: 'Batch number already exists',
    serialNumberExists: 'Serial number already exists',
    expiringMedicines: 'Expiring Medicines',
    expiredMedicines: 'Expired Medicines',
    daysUntilExpiry: 'Days Until Expiry',
    daysExpired: 'Days Expired',
    availableMedicines: 'Available Medicines',
    medicineDetails: 'Medicine Details',
    saveSuccess: 'Medicine saved successfully',
    saveError: 'Failed to save medicine',
    deleteSuccess: 'Medicine deleted successfully',
    deleteError: 'Failed to delete medicine',
    noMedicines: 'No medicines',
    loading: 'Loading medicines...',
    error: 'Failed to load medicines',
    selectItem: 'Select Item',
    selectStore: 'Select Store',
    enableMedicineTracking: 'Enable Medicine Tracking',
    enableSFDATracking: 'Enable SFDA Tracking',
    medicineTrackingEnabled: 'Medicine Tracking Enabled',
    sfdTrackingEnabled: 'SFDA Tracking Enabled',
    selectAvailable: 'Select Available',
    scanOrPasteQR: 'Scan or paste QR code here',
    qrScannerTip: '💡 Tip: You can use a physical QR scanner or paste the code directly',
    expired: 'Expired',
    expiringSoon: 'Expiring Soon',
    medicineFound: 'Medicine found',
    medicineRecordCreated: 'Medicine record created successfully',
    confirmDelete: 'Are you sure you want to delete this medicine?',
  },
  fr: {
    // French uses English labels as a fallback
    title: 'Medicine Tracking',
    addNew: 'Add New Medicine',
    item: 'Item',
    store: 'Store',
    branch: 'Branch',
    qrCode: 'QR Code',
    serialNumber: 'Serial Number',
    batchNumber: 'Batch Number',
    gtin: 'GTIN',
    productionDate: 'Production Date',
    expiryDate: 'Expiry Date',
    manufacturingDate: 'Manufacturing Date',
    receivedDate: 'Received Date',
    initialQuantity: 'Initial Quantity',
    currentQuantity: 'Current Quantity',
    unitCost: 'Unit Cost',
    supplier: 'Supplier',
    notes: 'Notes',
    isActive: 'Active',
    isExpired: 'Expired',
    sfdaProductCode: 'SFDA Product Code',
    sfdaManufacturerCode: 'SFDA Manufacturer Code',
    sfdaAuthorizationNumber: 'SFDA Authorization Number',
    scanQR: 'Scan QR',
    parseQR: 'Parse QR',
    qrCodeData: 'QR Code Data',
    invalidQRCode: 'Invalid QR Code',
    qrCodeNotFound: 'QR Code not found',
    batchNumberExists: 'Batch number already exists',
    serialNumberExists: 'Serial number already exists',
    expiringMedicines: 'Expiring Medicines',
    expiredMedicines: 'Expired Medicines',
    daysUntilExpiry: 'Days Until Expiry',
    daysExpired: 'Days Expired',
    availableMedicines: 'Available Medicines',
    medicineDetails: 'Medicine Details',
    saveSuccess: 'Medicine saved successfully',
    saveError: 'Failed to save medicine',
    deleteSuccess: 'Medicine deleted successfully',
    deleteError: 'Failed to delete medicine',
    noMedicines: 'No medicines',
    loading: 'Loading medicines...',
    error: 'Failed to load medicines',
    selectItem: 'Select Item',
    selectStore: 'Select Store',
    enableMedicineTracking: 'Enable Medicine Tracking',
    enableSFDATracking: 'Enable SFDA Tracking',
    medicineTrackingEnabled: 'Medicine Tracking Enabled',
    sfdTrackingEnabled: 'SFDA Tracking Enabled',
    selectAvailable: 'Select Available',
    scanOrPasteQR: 'Scan or paste QR code here',
    qrScannerTip: '💡 Tip: You can use a physical QR scanner or paste the code directly',
    expired: 'Expired',
    expiringSoon: 'Expiring Soon',
    medicineFound: 'Medicine found',
    medicineRecordCreated: 'Medicine record created successfully',
    confirmDelete: 'Are you sure you want to delete this medicine?',
  },
}


